import { render, staticRenderFns } from "./RigheSpedizioneList.vue?vue&type=template&id=7ab02775"
import script from "./RigheSpedizioneList.vue?vue&type=script&lang=ts"
export * from "./RigheSpedizioneList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab02775')) {
      api.createRecord('7ab02775', component.options)
    } else {
      api.reload('7ab02775', component.options)
    }
    module.hot.accept("./RigheSpedizioneList.vue?vue&type=template&id=7ab02775", function () {
      api.rerender('7ab02775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RigheSpedizioneList.vue"
export default component.exports